import { testFbId, apiServerTimestamp } from './index'
import { rgxFirebaseKey, apiMassiveUpdate, apiGetCurrentUser, apiGenerateEntityID, apiGetUserId, apiGetUserDetails, getUserByID, getScaleByID } from './firebase'

import { apiUrl } from '@/constants'

import { httpRequest } from '@/services/api'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

//
//
//

//
// ACEITAR SOLICITAÇÃO DE PASSAGEM DE PLANTÃO
//

const apiAcceptDuty = payload => httpRequest({ method: 'POST', url: `${apiUrl}/aceitar_plantao`, payload })

//
// ATUALIZAR DETALHES DO PLANTÃO: PLANTONISTA, VALOR E OBSERVAÇÃO
//

const apiUpdateDuty = payload => httpRequest({ method: 'POST', url: `${apiUrl}/atualizar_plantao`, payload })

//
// DIVIDIR PLANTÃO
//

const apiSplitDuty = payload => httpRequest({ method: 'POST', url: `${apiUrl}/dividir_plantao`, payload })

//
//
//

const isValidUserID = uid => !!uid === true && String(uid) !== '0' && /[A-Za-z0-9\-_]{10,256}/.test(String(uid))

const loadUsers = async (loadedGroupUsers, users) => (await Promise.all(
  [...users].map(async userID => {
    const groupUser = loadedGroupUsers.find(user => user.userID === userID) // Nota: Tenta encontrar o usuário na lista de usuários do grupo.
    const perfil = !!groupUser === true && !!groupUser.backup === true ? groupUser.backup : await getUserByID(userID) // Nota: Não conseguiu? Carrega à partir BD.

    return !!perfil === true ? { userID, userName: !!perfil.nome === true ? String(perfil.nome).trim() : '[ERRO]', userImage: !!perfil.img === true && String(perfil.img).includes('https://firebasestorage.googleapis.com/') ? String(perfil.img).trim() : '' } : false
  })
)).filter(x => !!x === true)

const loadScales = async (groupID, scales) => (await Promise.all(
  [...scales].map(async scaleID => {
    const scale = await getScaleByID(groupID, scaleID) // Nota: Carrega os detalhes da escala à partir BD.

    return !!scale === true ? { scaleID, scaleName: !!scale.type === true ? String(scale.type).trim() : '[ERRO]', availableShiftsColor: scale.availableShiftsColor || '#00cb72', ownedShiftsColor: scale.ownedShiftsColor || '#2196f3' } : false
  })
)).filter(x => !!x === true)

/* const getTaskTimezoneOffset = (task, timezone = -3) => !!task.dutyStartDateTZ && task.dutyStartDateTZ === '+0000' ? 0 : ((timezone || -3) * 60 * 60 * 1000) */

// Retorna um objeto contendo dia, mês e ano do plantão e HORÁRIO DE INÍCIO (se houver)
const formatUnixTimestamp = (timestamp, timezoneOffset = 0) => {
  const datetimeObj = new Date(timestamp + timezoneOffset)

  /* const datetimeObj = !!timezoneOffset === true ? (
    new Date( Date.parse(new Date(timestamp).toLocaleString('en-US', { timeZone: 'UTC' })) + timezoneOffset )
  ) : (
    new Date( Date.parse(new Date(timestamp).toLocaleString('en-US', { timeZone: 'UTC' })) )
  ) */

  const day = String(datetimeObj.getDate()).padStart(2, '0')
  const month = String(datetimeObj.getMonth() + 1).padStart(2, '0')
  const year = String(datetimeObj.getFullYear())
  const hours = String(datetimeObj.getHours()).padStart(2, '0')
  const minutes = String(datetimeObj.getMinutes()).padStart(2, '0')
  const seconds = String(datetimeObj.getSeconds()).padStart(2, '0')

  return { date: `${day}/${month}/${year}`, time: `${hours}:${minutes}:${seconds}` }
}

//
//
//

// Retorna a diferença em horas entre dois timestamps Unix
const calculateDifference = (startTimestamp, endTimestamp) => {
  const millisecondsDifference = endTimestamp - startTimestamp

  const hours = Math.floor(millisecondsDifference / (1000 * 60 * 60))
  const minutes = Math.floor((millisecondsDifference % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((millisecondsDifference % (1000 * 60)) / 1000)

  const difference = []
  if (hours > 0) difference.push(`${hours} hora${hours > 1 ? 's' : ''}`)
  if (minutes > 0) difference.push(`${minutes} minuto${minutes > 1 ? 's' : ''}`)
  if (seconds > 0) difference.push(`${seconds} segundo${seconds > 1 ? 's' : ''}`)

  if (difference.length > 1) {
    const lastPart = difference.pop()
    return difference.join(', ') + ' e ' + lastPart
  }

  return difference.join(', ')
}

const getShiftPause = s => {
  // "Referência da última pausa" encontrado = SE PASSAR POR TODOS OS ERROS SEM ACUSAR ALGUM, ENTÃO ESTÁ CORRETO, O PLANTÃO NUNCA FOI PAUSADO
  if (!!s.lastbreakstatus === false || !!s.lastbreakid === false || !!s.breaks === false) return { status: 'waiting', output: '' }

  // Detalhes da última pausa
  const lastBreak = s.breaks[s.lastbreakid] || false

  // "Timestamp de início da última pausa"
  const startTimestamp = !!lastBreak === true && !!lastBreak.start === true && !!lastBreak.start.timestamp === true ? lastBreak.start.timestamp : 0

  // "Timestamp de início da última pausa" não encontrado? Termina aqui com erro.
  if (!!startTimestamp === false) return { status: 'error', output: 'malformed' }

  // "Data e horário de início da última pausa"
  const startDateTime = formatUnixTimestamp(startTimestamp, 0)

  if (!!lastBreak.end === false) return { status: 'started', output: { startDate: startDateTime.date, startTime: startDateTime.time, endDate: '', endTime: '' } }

  // "Timestamp do fim da última pausa"
  const endTimestamp = !!lastBreak.end === true && !!lastBreak.end.timestamp === true ? lastBreak.end.timestamp : 0

  // (QUANDO HOUVER REGISTRO DE FINALIZAÇÃO) "Timestamp do fim da última pausa" não encontrado? Termina aqui com erro.
  if (!!lastBreak.end === true && !!lastBreak.end.timestamp === false) return { status: 'error', output: 'malformed' }

  // "Data e horário do fim da última pausa"
  const endDateTime = formatUnixTimestamp(endTimestamp, 0)

  // Calcula a diferença em horas entre os timestamps de início e fim da pausa
  const duration = calculateDifference(startTimestamp, endTimestamp)

  return {
    status: startDateTime.date === endDateTime.date ? 'finished' : 'finished_in_different_dates',
    output: { startDate: startDateTime.date, startTime: startDateTime.time, endDate: endDateTime.date, endTime: endDateTime.time, duration },
  }
}

/**
 *
 * FUNÇÕES UTILITÁRIAS USADAS SOMENTE NESSE ARQUIVO
 *
 */

const processShiftDetails = shift => {
  return {
    dutyStartDate: shift.dutyStartDateTZ && shift.dutyStartDateTZ === '+0000' ? moment.utc(shift.data_inicio).format('DD/MM/YYYY') : moment(shift.data_inicio).format('DD/MM/YYYY'),
    dutyStartTime: shift.hora_inicio || '',
    dutyLocation: !!shift.local && !!shift.local.nome ? String(shift.local.nome).trim() : '',
    dutyScaleName: !!shift.nome === true ? String(shift.nome).trim() : '', // Nome da escala do plantão?
    dutyValue: parseFloat(shift.valor || 0).toFixed(2),
  }
}

/**
 *
 * PROCESSA LISTA DE PLANTÕES
 *
 * - [Routes] Agenda (assumidos ou repassados)
 * - [GroupDuties] Grupo > Aba plantões
 *
 */

const isValidDuty = duty => {
  const rgxHoraInicio = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/
  const rgxDuracao = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/

  /* return !!duty && !!duty.groupID && !!duty.data_inicio && !!duty.status && !!duty.periodo && !!duty.uid && !!duty.uid_pegou && !!duty.nome */

  const groupIdByGrupos = !!duty.grupos === true ? Object.keys(duty.grupos)[0] : false

  // [24/01/25] console.log('isValidDuty:', duty)

  // OBJETO DE PLANTÃO
  const testA = (
    !!duty === true &&
    typeof duty === 'object'
  )
  // &&
  // ID DO GRUPO
  const testB = (
    (!!duty.groupID === true && rgxFirebaseKey.test(duty.groupID)) ||
    (!!duty.grupos === true && groupIdByGrupos !== false)
  )
  // &&
  // DATA INÍCIO
  const testC = (
    !!duty.data_inicio === true &&
    (
      // timestamp
      (
        typeof duty.data_inicio === 'number' &&
        // 01/01/2010 até 01/01/2050
        (duty.data_inicio >= 1262311200 || duty.data_inicio <= 2524618800)
      ) ||
      // TZ
      (
        typeof duty.data_inicio === 'string' &&
        duty.data_inicio.length >= 20 &&
        duty.data_inicio.length <= 32
      )
    )
  )
  // &&
  // DATA INÍCIO
  const testD = (
    !!duty.hora_inicio === true &&
    typeof duty.hora_inicio === 'string' &&
    rgxHoraInicio.test(duty.hora_inicio)
  )
  // &&
  // STATUS
  const testE = (
    !!duty.status === true &&
    (
      duty.status === 'fechado' ||
      duty.status === 'cancelado' ||
      duty.status === 'aberto'
    )
  )
  // &&
  const testF = (
    // PERIODO
    !!duty.periodo === true &&
    (
      (typeof duty.periodo === 'number' && (duty.periodo >= 1 || duty.periodo <= 24)) ||
      (
        typeof duty.periodo === 'string' && (
          (
            duty.periodo === '1' ||
            duty.periodo === '2' ||
            duty.periodo === '3' ||
            duty.periodo === '4' ||
            duty.periodo === '5' ||
            duty.periodo === '6' ||
            duty.periodo === '7' ||
            duty.periodo === '8' ||
            duty.periodo === '9' ||
            duty.periodo === '10' ||
            duty.periodo === '11' ||
            duty.periodo === '12' ||
            duty.periodo === '13' ||
            duty.periodo === '14' ||
            duty.periodo === '15' ||
            duty.periodo === '16' ||
            duty.periodo === '17' ||
            duty.periodo === '18' ||
            duty.periodo === '19' ||
            duty.periodo === '20' ||
            duty.periodo === '21' ||
            duty.periodo === '22' ||
            duty.periodo === '23' ||
            duty.periodo === '24'
          ) ||
          rgxDuracao.test(duty.periodo) ||
          // JESUS
          // JESUS
          // JESUS
          duty.periodo === '24:00'
        )
      )
    )
    // confirmar no gestor
  )
  // &&
  const testG = (
    // ID DO CRIADOR
    !!duty.uid === true && rgxFirebaseKey.test(duty.uid)
  )
  // &&
  const testH = (
    // ID DE QUEM PEGOU
    duty.uid_pegou === 0 ||
    duty.uid_pegou === '0' ||
    (!!duty.uid_pegou === true && rgxFirebaseKey.test(duty.uid_pegou)) ||
    (!!duty.uid_pegou === false && duty.uid_pegou !== 0)
  )

  return (
    testA &&
    testB &&
    testC &&
    testD &&
    testE &&
    testF &&
    testG &&
    testH
  )
}

/**
 *
 * LISTENERS
 *
 */

/* const apiGetDutyRef = dutyID => {
  return testFbId.ref(`plantoes/${dutyID}`)
} */

//
//
//
// testar FUSO HORÁRIO
//
// + testar owner_data / creator_data
//
//
//

const apiGetUserShiftsBetweenTwoDatesRef = (userID = false, primeiraData = false, ultimaData = false) => {
  if (!!userID === false || !!primeiraData === false || !!ultimaData === false) return false

  //

  const firstDateDay = primeiraData.date()
  const firstDateMonth = primeiraData.month()
  const firstDateYear = primeiraData.year()

  const firstDate = moment.utc([firstDateYear, firstDateMonth, firstDateDay, 0, 0, 0, 0]).startOf('day')
  const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  const startOfMonth = firstDate.unix() * 1000
  const startTimestamp = `${userID}_${startOfMonth}`

  //

  const ud = ultimaData.endOf('day') // corrigir exibição do último dia do mês
  const lastDateDay = ud.date()
  const lastDateMonth = ud.month()
  const lastDateYear = ud.year()

  const lastDate = moment.utc([lastDateYear, lastDateMonth, lastDateDay, 0, 0, 0, 0]).endOf('day')
  const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')
  const endOfMonth = lastDate.unix() * 1000
  const endTimestamp = `${userID}_${endOfMonth}`

  //

  // [24/01/25] console.log(`::: [LISTENER] GET USER (Id: ${userID}) SHIFTS BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, startTimestamp, endTimestamp)

  // const snapshot = await testFbId.ref('plantoes').orderByChild('owner_data').startAt(startTimestamp).endAt(endTimestamp).once('value')

  // return (snapshot && snapshot.val()) ? snapshot.val() : false

  return testFbId.ref('plantoes').orderByChild('owner_data').startAt(startTimestamp).endAt(endTimestamp)
}

const apiGetUserShiftsBetweenTwoDates = async (userID = false, primeiraData = false, ultimaData = false) => {
  if (!!userID === false || !!primeiraData === false || !!ultimaData === false) return false

  //

  const firstDateDay = primeiraData.date()
  const firstDateMonth = primeiraData.month()
  const firstDateYear = primeiraData.year()

  const firstDate = moment.utc([firstDateYear, firstDateMonth, firstDateDay, 0, 0, 0, 0]).startOf('day')
  const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  const startOfMonth = firstDate.unix() * 1000
  const startTimestamp = `${userID}_${startOfMonth}`

  //

  const ud = ultimaData.endOf('day') // corrigir exibição do último dia do mês
  const lastDateDay = ud.date()
  const lastDateMonth = ud.month()
  const lastDateYear = ud.year()

  const lastDate = moment.utc([lastDateYear, lastDateMonth, lastDateDay, 0, 0, 0, 0]).endOf('day')
  const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')
  const endOfMonth = lastDate.unix() * 1000
  const endTimestamp = `${userID}_${endOfMonth}`

  //

  // [24/01/25] console.log(`::: GET USER (Id: ${userID}) SHIFTS BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, startTimestamp, endTimestamp)

  const snapshot = await testFbId.ref('plantoes').orderByChild('owner_data').startAt(startTimestamp).endAt(endTimestamp).once('value')

  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

const apiGetGroupShifts = async (groupID = false, primeiraData = false, ultimaData = false) => {
  if (!!groupID === false || !!primeiraData === false || !!ultimaData === false) return false

  //

  const firstDateDay = primeiraData.date()
  const firstDateMonth = primeiraData.month()
  const firstDateYear = primeiraData.year()

  const firstDate = moment.utc([firstDateYear, firstDateMonth, firstDateDay, 0, 0, 0, 0]).startOf('day')
  const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  const startOfMonth = firstDate.unix() * 1000
  const startTimestamp = `${groupID}_${startOfMonth}`

  //

  const ud = ultimaData.endOf('day') // corrigir exibição do último dia do mês
  const lastDateDay = ud.date()
  const lastDateMonth = ud.month()
  const lastDateYear = ud.year()

  const lastDate = moment.utc([lastDateYear, lastDateMonth, lastDateDay, 0, 0, 0, 0]).endOf('day')
  const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')
  const endOfMonth = lastDate.unix() * 1000
  const endTimestamp = `${groupID}_${endOfMonth}`

  //

  // [24/01/25] console.log(`::: GET GROUP (Id: ${groupID}) SHIFTS BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, startTimestamp, endTimestamp)

  const snapshot = await testFbId.ref('plantoes').orderByChild('group_data').startAt(startTimestamp).endAt(endTimestamp).once('value')

  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

const apiGetGroupStatistics = async (groupID, timestampRange = {}) => {
  const snapshot = !!timestampRange === true && !!timestampRange.start === true && !!timestampRange.end === true ? await testFbId.ref('plantoes').orderByChild('group_data').startAt(`${groupID}_${timestampRange.start}`).endAt(`${groupID}_${timestampRange.end}`).once('value') : await testFbId.ref('plantoes').orderByChild('groupID').equalTo(groupID).once('value')
  return snapshot.val() ? Object.entries(snapshot.val()) : []
}

/* const apiGetGroupShiftsByMonthYear = async (groupId = false, month = false, year = false) => {
  if (!!groupId === false || !!month === false || !!year === false) return false

  const dateMonth = parseInt(month) - 1
  const dateYear = parseInt(year)

  const firstDate = moment.utc([dateYear, dateMonth, 1, 0, 0, 0, 0]).startOf('month')
  const lastDate = moment.utc([dateYear, dateMonth, 1, 0, 0, 0, 0]).endOf('month')

  // firstDate = obj.firstDate
  // lastDate = obj.lastDate.endOf('day') // corrigir exibição do último dia do mês

  const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')

  const startOfMonth = firstDate.unix() * 1000
  const endOfMonth = lastDate.unix() * 1000

  const startTimestamp = `${groupId}_${startOfMonth}`
  const endTimestamp = `${groupId}_${endOfMonth}`

  // [24/01/25] console.log(`::: [apiGetGroupShiftsByMonthYear] GET GROUP SHIFTS BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, groupId, startTimestamp, endTimestamp)

  const snapshot = await testFbId.ref('plantoes').orderByChild('group_data').startAt(startTimestamp).endAt(endTimestamp).once('value')

  return (snapshot && snapshot.val()) ? snapshot.val() : false
} */

// observar data_inicio e atualizações de plantão / escala / turno (seleção de plantões por range/periodo)

const apiGetGroupShiftsRef = (groupId = false, inicio = false, fim = false) => {
  if (!!groupId === false || !!inicio === false || !!fim === false) return false

  const firstDate = inicio.clone().utc().startOf('day') // JESUS - Exibição do primeiro dia do mês não funcionando (CORRIGIDO EM 01/05/2024)
  const lastDate = fim.clone().utc().endOf('day') // Corrigir exibição do último dia do mês

  const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')

  const startOfMonth = firstDate.unix() * 1000
  const endOfMonth = lastDate.unix() * 1000

  const startTimestamp = `${groupId}_${startOfMonth}`
  const endTimestamp = `${groupId}_${endOfMonth}`

  // [24/01/25] console.log(`::: GET GROUP SHIFTS BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, groupId, startTimestamp, endTimestamp)

  return testFbId.ref('plantoes').orderByChild('group_data').startAt(startTimestamp).endAt(endTimestamp)
}

const apiGetScaleDutiesRef = (scaleId = false, obj = {}) => {
  if (!!scaleId === false || !!obj === false || typeof obj !== 'object' || Array.isArray(obj)) return false

  //
  // apiGetScaleDutiesRef(scaleID, { type: 'userduties', month, year })
  // apiGetScaleDutiesRef(this.localScaleID, { type: 'viewscale', firstDate, lastDate })
  //

  let firstDate
  let lastDate

  if (obj.type === 'userduties') {
    const dateMonth = parseInt(obj.month) - 1
    const dateYear = parseInt(obj.year)
    firstDate = moment.utc([dateYear, dateMonth, 1, 0, 0, 0, 0]).startOf('month')
    lastDate = moment.utc([dateYear, dateMonth, 1, 0, 0, 0, 0]).endOf('month')
  } else {
    const primeiraData = obj.firstDate
    const firstDateDay = primeiraData.date()
    const firstDateMonth = primeiraData.month()
    const firstDateYear = primeiraData.year()
    firstDate = moment.utc([firstDateYear, firstDateMonth, firstDateDay, 0, 0, 0, 0]).startOf('day')

    const ultimaData = obj.lastDate.endOf('day') // corrigir exibição do último dia do mês
    const lastDateDay = ultimaData.date()
    const lastDateMonth = ultimaData.month()
    const lastDateYear = ultimaData.year()
    lastDate = moment.utc([lastDateYear, lastDateMonth, lastDateDay, 0, 0, 0, 0]).endOf('day')
  }

  // const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  // const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')

  const startOfMonth = firstDate.unix() * 1000
  const endOfMonth = lastDate.unix() * 1000

  // 10800000 - RETIRAR 3 HORAS
  const startTimestamp = `${scaleId}_${startOfMonth}`
  const endTimestamp = `${scaleId}_${endOfMonth}`

  // console.log(`::: GET SCALE DUTIES BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, scaleId, obj, startTimestamp, endTimestamp)

  return testFbId.ref('plantoes').orderByChild('scale_data').startAt(startTimestamp).endAt(endTimestamp)
}

const apiGetDailyReportDuties = async (groupId = false, day = false, month = false, year = false) =>
{
  if (day === false || month === false || year === false) return false

  const dateDay = parseInt(day)
  const dateMonth = parseInt(month) - 1
  const dateYear = parseInt(year)

  const yesterdayDate = moment.utc([dateYear, dateMonth, dateDay, 0, 0, 0, 0]).subtract(1, 'day') // yesterday (start)
  const yesterdayTimestamp = yesterdayDate.unix() * 1000
  const startTimestamp = `${groupId}_${yesterdayTimestamp}`

  const todayDate = moment.utc([dateYear, dateMonth, dateDay, 23, 59, 59, 0]) // today (end)
  const todayTimestamp = todayDate.unix() * 1000
  const endTimestamp = `${groupId}_${todayTimestamp}`

  // [24/01/25] console.log('::: apiGetDailyReportDuties -> D/M/YYYY:', dateDay, dateMonth, dateYear)
  // [24/01/25] console.log('::: apiGetDailyReportDuties -> timestamp:', startTimestamp, endTimestamp)

  const snapshot = await testFbId.ref('plantoes').orderByChild('group_data').startAt(startTimestamp).endAt(endTimestamp).once('value')

  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

/**
 *
 * ?
 *
 */

/* const apiGetScaleDuties = async (scaleId = false, month = false, year = false) => {
  if (scaleId === false || month === false || year === false) return false

  const dateYear = parseInt(year)
  const dateMonth = parseInt(month) - 1

  const firstDate = moment.utc([dateYear, dateMonth, 1, 0, 0, 0, 0]).startOf('month')
  const lastDate = moment.utc([dateYear, dateMonth, 1, 0, 0, 0, 0]).endOf('month')

  const startOfMonthFmt = firstDate.format('YYYY-MM-DD HH:mm:ss')
  const endOfMonthFmt = lastDate.format('YYYY-MM-DD HH:mm:ss')

  const startOfMonth = firstDate.unix() * 1000
  const endOfMonth = lastDate.unix() * 1000

  const startTimestamp = `${scaleId}_${startOfMonth}`
  const endTimestamp = `${scaleId}_${endOfMonth}`

  // [24/01/25] console.log(`::: GET SCALE DUTIES BETWEEN ${startOfMonthFmt} AND ${endOfMonthFmt}:`, startTimestamp, endTimestamp)

  const snapshot = await testFbId.ref('plantoes').orderByChild('scale_data').startAt(startTimestamp).endAt(endTimestamp).once('value')

  return (snapshot && snapshot.val()) ? snapshot.val() : false
} */

const getDutyByID = async dutyID => {
  const dutyRequest = await testFbId.ref(`plantoes/${dutyID}`).once('value')
  const duty = (dutyRequest && dutyRequest.val()) ? dutyRequest.val() : false
  return (duty && typeof duty === 'object') ? duty : false
}

const apiGetShiftHistory = async dutyID => {
  const snapshot = await testFbId.ref(`logs/plantoes/${dutyID}`).orderByChild('timestamp').once('value')
  return !!snapshot === true && !!snapshot.val() === true && typeof snapshot.val() === 'object' ? Object.entries(snapshot.val()) : []
}

const apiGetGroupDutyChatMessages = async (groupID, dutyID) => {
  const snapshot = await testFbId.ref('chats/' + groupID + '/chats').orderByChild('plantaoID').equalTo(dutyID).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

/* const apiGetShiftUserNotifications = async shiftID => {
  const snapshot = await testFbId.ref('notificacoes').orderByChild('plantaoID').equalTo(shiftID).once('value')
  return snapshot && snapshot.val() ? snapshot.val() : false
} */

/**
 *
 * ?
 *
 */

const createDutyObject = (p = {
  scaleConsultationDuration: false,

  dutyGroupID: '',
  dutyScaleID: '',
  dutyCreatorID: '',
  dutyOwnerID: '',

  dutyMessageDate: '',
  dataInicioFmt: '',

  dutyStartDate: '',
  dutyStartTime: '',
  dutyDuration: 0,

  dutyName: '',
  dutyLocal: '',

  dutyValue: 0,

  preventAvailableDutyNotification: false, // inglês
  isUserDuty: true,
  updateGroup: true,
  turnPath: false,

  dutyCreatorName: '',
  dutyGroupName: '',
}) => {
  const newDutyID = apiGenerateEntityID('plantoes')

  const newDuty = {
    // TEMPO DE CONSULTA - TELEMEDICINA
    tempo_consulta: p.scaleConsultationDuration,

    // ESTRUTURA PADRÃO
    dutyStartDateTZ: '+0000',
    dataInicioFmt: p.dataInicioFmt,
    origem: 1, // 1 = web / 0 = app
    local: {
      nome: p.dutyLocal,
    },
    grupos: {
      [p.dutyGroupID]: true,
    },
    nome: p.dutyName,
    // des: '', // ATUAL dutyType / ANTIGO type (REFERÊNCIA DO APP)
    periodo: p.dutyDuration,
    status: p.isUserDuty ? 'fechado' : 'aberto',
    data_inicio: p.dutyStartDate,
    hora_inicio: p.dutyStartTime,
    uid: p.dutyCreatorID,
    uid_pegou: p.isUserDuty ? p.dutyOwnerID : 0,
    valor: p.dutyValue,
    groupID: p.dutyGroupID,
    scaleID: p.dutyScaleID,
    group_data: `${p.dutyGroupID}_${p.dutyStartDate}`,
    scale_data: `${p.dutyScaleID}_${p.dutyStartDate}`,
    creator_data: `${p.dutyCreatorID}_${p.dutyStartDate}`,
  }

  if (p.isUserDuty) newDuty.owner_data = `${p.dutyOwnerID}_${p.dutyStartDate}`

  if (p.preventAvailableDutyNotification === true) {
    // if (!isUserDuty) {
    newDuty.notify = 'no' // Marca o plantão para não ser notificado por "push notification"
  }

  const fullUpdate = {}

  /* INCLUI PLANTÃO */
  fullUpdate['plantoes/' + newDutyID] = newDuty

  /* INCLUI PLANTÃO NO GRUPO */
  // fullUpdate['grupos/' + p.dutyGroupID + '/plantoes/' + newDutyID] = true

  /* ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS */
  if (p.updateGroup === true) {
    fullUpdate['grupos/' + p.dutyGroupID + '/data_atual'] = apiServerTimestamp()
  }

  /* INCLUI PLANTÃO NO TURNO (ESCALA) */
  if (p.turnPath !== false) {
    fullUpdate[p.turnPath + '/plantoesIDs/' + newDutyID] = true
  }

  if (p.isUserDuty)
  {
    const newNotificationID = apiGenerateEntityID('notificacoes')

    /* NOVO ITEM NA LISTA DE NOTIFICAÇÕES DO APP */
    fullUpdate['notificacoes/' + newNotificationID] = {
      plantaoID: newDutyID, // vai ajudar a apagar notificações após apagar um plantão no gestor // [SENHOR JESUS]
      uid: p.dutyOwnerID,
      titulo: 'Um plantão foi criado para você.',
      mensagem: `O plantão "${p.dutyName}", no dia ${p.dutyMessageDate} foi criado para você. Confira seu calendário.`,
      timestamp: apiServerTimestamp(),
    }

    // mensagem: `O plantão "${p.dutyName}", no dia ${p.dutyMessageDate} foi passado para você. Confira seu calendário.`,
  }
  else // disponível (p.isUserDuty === false)
  {
    //
    // Notificar plantão disponível
    //
    // *** JESUS ESTÁ VIVO ***
    //

    if (p.preventAvailableDutyNotification === false)
    {
      const newChatID = apiGenerateEntityID(`chats/${p.dutyGroupID}/chats`)

      const messageTitle = `Novo Plantão disponível no grupo ${p.dutyGroupName}`

      fullUpdate['chats/' + p.dutyGroupID + '/chats/' + newChatID] = {
        tipo: 'new-duty',
        timestamp: apiServerTimestamp(),
        plantaoID: newDutyID,

        // Usuário que está executando a operação
        uid: p.dutyCreatorID,
        displayName: p.dutyCreatorName,

        // PARA APLICATIVOS NA VERSÃO DE SETEMBRO 2022 OU ANTERIOR
        mensagem: `${messageTitle}. (Detalhes: Início em ${p.dutyMessageDate || ''} às ${p.dutyStartTime || ''} na escala ${p.dutyName || ''})`,

        // Esse título é uma novidade implementado em Nov 2022 em algumas (ou todas) mensagens de chat de plantão
        message_title: messageTitle,
        message_data: {
          // Detalhes do plantão
          dutyStartDate: p.dutyMessageDate || '',
          dutyStartTime: p.dutyStartTime || '',
          dutyLocation: p.dutyLocal || '',
          dutyScaleName: p.dutyName || '',
          dutyValue: parseFloat(p.dutyValue || 0).toFixed(2),
        },
      }
    }
  }

  return fullUpdate
}

const apiCreateDuty = async (
  p = [{
    scaleConsultationDuration: false,

    dutyGroupID: '',
    dutyScaleID: '',
    dutyOwnerID: '',

    dutyMessageDate: '',
    dataInicioFmt: '',

    dutyStartDate: '',
    dutyStartTime: '',
    dutyDuration: 0,

    dutyName: '',
    dutyLocal: '',

    dutyValue: 0,
  }],

  customCallback
) => {
  // CRIADOR
  var authUser = apiGetCurrentUser()
  var dutyCreatorID = authUser.uid

  // CRIA A ESTRUTURA DE DADOS DO PLANTÃO
  let fullUpdate = {}

  p.forEach(plantao => {
    fullUpdate = {
      ...fullUpdate,
      ...createDutyObject({
        scaleConsultationDuration: plantao.scaleConsultationDuration,

        dutyGroupID: plantao.dutyGroupID,
        dutyScaleID: plantao.dutyScaleID,
        dutyCreatorID,
        dutyOwnerID: plantao.dutyOwnerID,
        dutyMessageDate: plantao.dutyMessageDate,
        dataInicioFmt: plantao.dataInicioFmt,
        dutyStartDate: plantao.dutyStartDate,
        dutyStartTime: plantao.dutyStartTime,
        dutyDuration: plantao.dutyDuration,
        dutyName: plantao.dutyName,
        dutyLocal: plantao.dutyLocal,
        dutyValue: plantao.dutyValue,
        preventAvailableDutyNotification: false, // inglês
        isUserDuty: true,
        updateGroup: true,
        turnPath: false,
      }),
    }
  })

  // INSERE NO BANCO DE DADOS
  apiMassiveUpdate(fullUpdate, response => customCallback(response))
}

/**
 *
 * RECUSAR SOLICITAÇÃO DE PASSAGEM DE PLANTÃO
 *
 */

const apiRefuseDuty = async (dutyId, groupId, viewerIsGroupAdmin, isCancelation = false) => {
  const requesterId = apiGetUserId()
  const requesterProfile = await apiGetUserDetails(requesterId)

  const duty = await getDutyByID(dutyId)

  const ownerId = !!duty && !!duty.uid_pegou && rgxFirebaseKey.test(duty.uid_pegou) ? duty.uid_pegou : false

  const receivingId = !!duty && !!duty.uid_pegando && rgxFirebaseKey.test(duty.uid_pegando) ? duty.uid_pegando : false
  const receivingProfile = !!receivingId === true ? await apiGetUserDetails(receivingId) : false

  // Dados do plantonista que está recebendo a solicitação de aceitação ou recusa
  const receivingName = !!receivingProfile && !!receivingProfile.nome ? String(receivingProfile.nome).trim() : ''

  if (!!duty === false || !!requesterProfile === false)
  {
    return {
      code: 0,
      message: isCancelation ? 'Não foi possível cancelar a passagem do plantão. Por favor, tente novamente ou fale com o nosso suporte.' : 'Não foi possível recusar o plantão. Por favor, tente novamente ou fale com o nosso suporte.',
    }
  }
  else if (!!receivingId === false || !!receivingProfile === false)
  {
    return {
      code: 0,
      message: isCancelation ? 'Você não pode cancelar a passagem do plantão, pois ele não está compartilhado!' : 'Você não pode recusar o plantão, pois ele não está compartilhado!',
    }
  }
  else if (
    !viewerIsGroupAdmin
    && // eslint-disable-line operator-linebreak
    // O plantão não foi passado para VIEWER aceitar ou recusar
    !!receivingId && receivingId !== requesterId
    && // eslint-disable-line operator-linebreak
    // VIEWER não é plantonista desse plantão
    !!ownerId && ownerId !== requesterId
  )
  {
    return {
      code: 0,
      message: isCancelation ? 'Você não pode cancelar a passagem do plantão!' : 'Você não pode recusar o plantão, pois ele não foi passado para você!',
    }
  }
  else
  {
    //
    // INFORMAÇÕES QUE COMPÕE A MENSAGEM
    //

    // Detalhes do plantão
    const shiftDetails = processShiftDetails(duty)

    // O usuário que está operando está recebendo esse plantão?
    const isRequesterReceiving = requesterId === receivingId

    // Foi solicitado pelo plantonista ou por algum gestor?
    const isRequesterOwner = !!duty.uid_pegou && requesterId === duty.uid_pegou

    // Dados do plantonista
    const ownerId = !isRequesterOwner ? (duty.uid_pegou || 0) : requesterId
    const ownerProfile = !isRequesterOwner ? await apiGetUserDetails(duty.uid_pegou) : requesterProfile
    const ownerName = !!ownerProfile && !!ownerProfile.nome ? String(ownerProfile.nome).trim() : ''

    // Dados do plantonista ou gestor que está PASSANDO O PLANTÃO
    const requesterName = !!requesterProfile && !!requesterProfile.nome ? String(requesterProfile.nome).trim() : ''

    //
    // *** JESUS ESTÁ VIVO ***
    //

    const messageTitle = isRequesterOwner ? `Desistiu de passar o plantão para ${receivingName || 'outro usuário'}` : (isRequesterReceiving ? `Recusou o plantão de ${ownerName || 'outro usuário'}` : `Cancelou a passagem do plantão de ${ownerName || 'um usuário'} para ${receivingName || 'outro usuário'}`)

    const message = {
      tipo: 'refuse-duty', // NOVA VERSÃO DA MENSAGEM DE LARGAR PLANTÃO PARA GRUPO
      timestamp: apiServerTimestamp(),
      plantaoID: dutyId, // SENHOR JESUS

      // Solicitante (Próprio plantonista ou algum gestor)
      uid: requesterId,
      displayName: requesterName,

      // PARA APLICATIVOS NA VERSÃO DE SETEMBRO 2022 OU ANTERIOR
      mensagem: `${messageTitle}. (Detalhes: Início em ${shiftDetails.dutyStartDate} às ${shiftDetails.dutyStartTime} na escala ${shiftDetails.dutyScaleName})`,

      // Esse título é uma novidade implementado em Nov 2022 em algumas (ou todas) mensagens de chat de plantão
      message_title: messageTitle,
      message_data: {
        // Detalhes do plantão
        dutyStartDate: shiftDetails.dutyStartDate,
        dutyStartTime: shiftDetails.dutyStartTime,
        dutyLocation: shiftDetails.dutyLocation,
        dutyScaleName: shiftDetails.dutyScaleName,
        dutyValue: shiftDetails.dutyValue,

        // Usuário que está recebendo a solicitação de passagem
        receivingId,
        receivingName,

        // Plantonista
        ownerId,
        ownerName,
      },
    }

    //
    //
    //

    const messageId = apiGenerateEntityID(`chats/${groupId}/chats`)

    const updates = {}

    // Retira a referência do USUÁRIO QUE ESTÁ RECEBENDO, ou seja, desfaz a passagem do plantão
    updates[`plantoes/${dutyId}/uid_pegando`] = null

    // Mensagem no chat
    updates[`chats/${groupId}/chats/${messageId}`] = message

    //
    // Executa operações no banco de dados
    //

    // console.log('::: REFUSE DUTY -> updates:', updates)

    return new Promise((resolve, reject) => {
      try
      {
        testFbId.ref().update(updates,
        error => {
          if (error) {
            resolve({
              code: 0,
              message: isCancelation ? 'Não foi possível cancelar a passagem do plantão. Por favor, tente novamente ou fale com o nosso suporte.' : 'Não foi possível recusar o plantão. Por favor, tente novamente ou fale com o nosso suporte.',
            })
          } else {
            resolve({
              code: 1,
              message: '',
            })
          }
        })
      }
      catch (e)
      {
        resolve({
          code: 0,
          message: isCancelation ? 'Não foi possível cancelar a passagem do plantão. Por favor, tente novamente ou fale com o nosso suporte.' : 'Não foi possível recusar o plantão. Por favor, tente novamente ou fale com o nosso suporte.',
        })
      }
    })
  }
}

/**
 *
 * DEFINIR FIM DO PLANTÃO
 *
 */

const apiUndoShiftExecutionTime = async (shiftID = false, shiftEndObservation = '') => {
  if (!!shiftID === false) return false

  const updates = {
    ['plantoes/' + shiftID + '/start_location']: null,
    ['plantoes/' + shiftID + '/end_location']: null,
  }

  if (shiftEndObservation.length > 0) {
    updates['plantoes/' + shiftID + '/end_observation_backup'] = shiftEndObservation
  }

  //
  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível atualizar o plantão',
          })
        } else {
          resolve({
            code: 1,
            message: 'Os detalhes do plantão foram alterados!',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar o plantão',
      })
    }
  })
}

const apiStartAndFinishShiftByUser = async (args = { shiftID: false, managerID: '', startTimestamp: 0, endTimestamp: 0, observation: '' }) => {
  if (!!args === false || (!!args === true && !!args.shiftID === false)) return false

  const updates = {
    ['plantoes/' + args.shiftID + '/start_location']: {
      origin: 'GESTOR',
      managerID: args.managerID,
      timestamp: args.startTimestamp,
      latitude: 0,
      longitude: 0,
    },
    ['plantoes/' + args.shiftID + '/end_location']: {
      origin: 'GESTOR',
      managerID: args.managerID,
      timestamp: args.endTimestamp,
      latitude: 0,
      longitude: 0,
      observation: args.observation,
    },
    ['plantoes/' + args.shiftID + '/end_observation_backup']: null,
  }

  //
  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível atualizar o plantão',
          })
        } else {
          resolve({
            code: 1,
            message: 'Os detalhes do plantão foram alterados!',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar o plantão',
      })
    }
  })
}

const apiFinishShiftByUser = async (args = { shiftID: false, managerID: '', endTimestamp: 0, observation: '' }) => {
  if (!!args === false || (!!args === true && !!args.shiftID === false)) return false

  const updates = {
    ['plantoes/' + args.shiftID + '/end_location']: {
      origin: 'GESTOR',
      managerID: args.managerID,
      timestamp: args.endTimestamp,
      latitude: 0,
      longitude: 0,
      observation: args.observation,
    },
    ['plantoes/' + args.shiftID + '/end_observation_backup']: null,
  }

  //
  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível atualizar o plantão',
          })
        } else {
          resolve({
            code: 1,
            message: 'Os detalhes do plantão foram alterados!',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar o plantão',
      })
    }
  })
}

/**
 *
 * ATUALIZAR PLANTONISTA
 *
 */

const apiUpdateShiftOwner = async (dataInicio = false, dutyID = false, ownerID = '0') => {
  // [24/01/25] console.log(':: apiUpdateShiftOwner:', dataInicio, ownerID)

  const updates = {}

  updates['/plantoes/' + dutyID + '/uid_pegou'] = String(ownerID) !== '0' ? ownerID : 0
  updates['/plantoes/' + dutyID + '/status'] = String(ownerID) !== '0' ? 'fechado' : 'aberto'
  if (String(ownerID) !== '0') {
    updates['/plantoes/' + dutyID + '/owner_data'] = `${ownerID}_${dataInicio}`
    updates['/plantoes/' + dutyID + '/candidates'] = null
  }

  //
  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível atualizar o plantão',
          })
        } else {
          resolve({
            code: 1,
            message: 'Os detalhes do plantão foram alterados!',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar o plantão',
      })
    }
  })
}

/**
 *
 * CANCELAR SOLICITAÇÃO DE PLANTÃO DISPONÍVEL
 *
 */

const apiCancelShiftRequest = async (dutyID = false, ownerID = '0') => {
  // [24/01/25] console.log(':: apiCancelShiftRequest:', ownerID)

  const updates = {}

  updates['/plantoes/' + dutyID + '/candidates/' + ownerID] = null

  //
  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível atualizar o plantão',
          })
        } else {
          resolve({
            code: 1,
            message: 'Os detalhes do plantão foram alterados!',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        message: 'Não foi possível atualizar o plantão',
      })
    }
  })
}

/**
 *
 * APAGAR PLANTÃO
 *
 */

const apiDeleteDuty = async (dutyID = false, waitingDutyID = false, groupID = false) => {
  const fullUpdate = {}

  // RESTAURA O STATUS ORIGINAL DO PLANTÃO SINALIZADO QUE ORIGINOU ESSE PLANTÃO
  if (waitingDutyID !== false && typeof waitingDutyID === 'string') {
    fullUpdate['plantoes_sinalizados/' + waitingDutyID + '/dutyID'] = null
    fullUpdate['plantoes_sinalizados/' + waitingDutyID + '/dutyUpdated'] = null
    fullUpdate['plantoes_sinalizados/' + waitingDutyID + '/dutyStatus'] = 0
    fullUpdate['plantoes_sinalizados/' + waitingDutyID + '/dutyValue'] = 0
    fullUpdate['plantoes_sinalizados/' + waitingDutyID + '/dutyScaleValue'] = null
  }

  // APAGA PLANTÃO
  fullUpdate['plantoes/' + dutyID] = null

  // APAGA LOG DO PLANTÃO
  fullUpdate['logs/plantoes/' + dutyID] = null

  // APAGA PLANTÃO NO GRUPO
  // fullUpdate['grupos/' + groupID + '/plantoes/' + dutyID] = null

  // ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS
  fullUpdate['grupos/' + groupID + '/data_atual'] = apiServerTimestamp()

  // APAGAR NOTIFICAÇÃO DESSE PLANTÃO (ITEM NA LISTA DE NOTIFICAÇÕES DO APP)
  // fullUpdate['notificacoes/' + newNotificationID + '/plantaoID/' + dutyID] = null // erro?

  //
  // APAGA MENSAGEM DO CHAT (QUALQUER TIPO DE PLANTÃO)
  //
  // *** JESUS ESTÁ VIVO ***
  // *** JESUS ESTÁ VIVO ***
  // *** JESUS ESTÁ VIVO ***
  //

  const dutyChatNotifications = await apiGetGroupDutyChatMessages(groupID, dutyID)

  if (dutyChatNotifications !== false)
  {
    Object.keys(dutyChatNotifications).map(chatMessageKey => {
      fullUpdate['chats/' + groupID + '/chats/' + chatMessageKey] = null
    })
  }

  // [24/01/25] console.log(`::: DELETE SHIFT "${dutyID}":`, fullUpdate)

  //
  // ENVIA PARA O FIREBASE
  //

  return new Promise((resolve, reject) => {
    try
    {
      testFbId.ref().update(fullUpdate,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível apagar o plantão. Por favor, tente novamente ou contate nosso suporte.',
          })
        } else {
          resolve({
            code: 1,
            message: '',
          })
        }
      })
    }
    catch (e)
    {
      resolve({
        code: 0,
        message: 'Não foi possível apagar o plantão. Por favor, tente novamente ou contate nosso suporte.',
      })
    }
  })
}

/**
 *
 * ?
 *
 */

// ver waitingDutyID no plantoes/{plantao_ID}

const apiSetWaitingDutyStatus = async (dutyID, status = 0, data = false, customCallback) => {
  const dutyUpdated = moment().utc().unix() * 1000

  const fullUpdate = {}

  /* ATUALIZA PLANTÃO SINALIZADO */
  fullUpdate['plantoes_sinalizados/' + dutyID + '/dutyStatus'] = status
  fullUpdate['plantoes_sinalizados/' + dutyID + '/dutyUpdated'] = dutyUpdated

  /* GUARDA VALOR CALCULADO DO PLANTÃO SINALIZADO (ACEITO OU RECUSADO) + VALOR DA ESCALA NO MOMENTO DA AÇÃO */
  if (typeof data === 'object') {
    fullUpdate['plantoes_sinalizados/' + dutyID + '/dutyValue'] = data.dutyCalculatedValue
    fullUpdate['plantoes_sinalizados/' + dutyID + '/dutyScaleValue'] = data.dutyScaleValue || 0 // corrigir um bug gerado por não incluir data.duty no apiSetWaitingDutyStatus (/src/views/new/scales/Group.vue)
  }

  /* INCLUI PLANTÃO */
  if (status === 1 && typeof data === 'object') {
    var authUser = apiGetCurrentUser()
    var authUserID = authUser.uid

    const newDutyID = apiGenerateEntityID('plantoes') // dutyID_123
    // const newTurnID = apiGenerateEntityID('escalas/' + data.dutyGroupID + '/' + data.dutyScaleID + '/turnos') // turnID_123
    const newNotificationID = apiGenerateEntityID('notificacoes') // notificationID_123

    const newDuty = {
      // TEMPO DE CONSULTA - TELEMEDICINA
      tempo_consulta: data.duracaoConsulta,

      // ESTRUTURA PADRÃO
      dutyStartDateTZ: '+0000',
      dataInicioFmt: data.dataInicioFmt,
      origem: 0, // 1 = web / 0 = app
      local: {
        nome: data.dutyPlace,
      },
      grupos: {
        [data.dutyGroupID]: true,
      },
      nome: data.dutyName,
      des: data.dutyType, // ATUAL dutyType / ANTIGO type (REFERÊNCIA DO APP)
      periodo: data.durationBase,
      status: 'fechado',
      data_inicio: data.dutyDateTimestamp,
      hora_inicio: data.dutyTime,
      uid: authUserID,
      uid_pegou: data.dutyCreatorID,
      // valor: data.dutyValue,
      valor: data.dutyCalculatedValue,
      groupID: data.dutyGroupID,
      scaleID: data.dutyScaleID,
      group_data: `${data.dutyGroupID}_${data.dutyDateTimestamp}`,
      scale_data: `${data.dutyScaleID}_${data.dutyDateTimestamp}`,

      creator_data: `${data.authUserID}_${data.dutyDateTimestamp}`,
      owner_data: `${data.dutyCreatorID}_${data.dutyDateTimestamp}`,

      waitingDutyID: dutyID,
      waitingDutyScaleValue: data.dutyScaleValue || 0, // corrigir um bug gerado por não incluir data.duty no apiSetWaitingDutyStatus (/src/views/new/scales/Group.vue)
    }

    /* GUARDA ID DO NOVO PLANTÃO DENTRO DO PLANTÃO SINALIZADO */
    fullUpdate['plantoes_sinalizados/' + dutyID + '/dutyID'] = newDutyID

    /* INCLUI PLANTÃO */
    fullUpdate['plantoes/' + newDutyID] = newDuty

    /* INCLUI PLANTÃO NO GRUPO */
    // fullUpdate['grupos/' + data.dutyGroupID + '/plantoes/' + newDutyID] = true

    /* ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS */
    fullUpdate['grupos/' + data.dutyGroupID + '/data_atual'] = apiServerTimestamp()

    /* NOVO TURNO */
    // fullUpdate['escalas/' + data.dutyGroupID + '/' + data.dutyScaleID + '/turnos/' + newTurnID] = newTurn

    /* NOVO ITEM NA LISTA DE NOTIFICAÇÕES DO APP */
    fullUpdate['notificacoes/' + newNotificationID] = {
      plantaoID: newDutyID, // vai ajudar a apagar notificações após apagar um plantão no gestor // [SENHOR JESUS]
      uid: data.dutyCreatorID,
      titulo: 'Um plantão foi criado para você.',
      mensagem: 'O plantão "' + data.dutyName + '", no dia ' + data.dutyDateMsg + ' foi passado para você. Confira seu calendário.',
      timestamp: apiServerTimestamp(),
    }
  }

  // [24/01/25] console.log('::: PLANTÃO SINALIZADO[fullUpdate]:', fullUpdate)

  /**
   *
   * INSERE NO BANCO DE DADOS
   *
   */

  apiMassiveUpdate(fullUpdate, response => customCallback(response))
}

/**
 *
 * SAÍDA
 *
 */

export {
  apiAcceptDuty,
  apiUpdateDuty,
  apiSplitDuty,

  isValidUserID,
  loadUsers,
  loadScales,

  getShiftPause,

  isValidDuty,
  apiGetUserShiftsBetweenTwoDatesRef,
  apiGetUserShiftsBetweenTwoDates,
  apiGetGroupShifts,
  apiGetGroupStatistics,

  // apiGetDutyRef,
  // apiGetGroupShiftsByMonthYear,
  apiGetGroupShiftsRef,
  apiGetScaleDutiesRef,
  apiGetDailyReportDuties,

  // apiGetScaleDuties,
  getDutyByID,
  apiGetShiftHistory,
  apiGetGroupDutyChatMessages,

  createDutyObject,
  apiCreateDuty,

  apiRefuseDuty,

  apiUndoShiftExecutionTime,
  apiFinishShiftByUser,
  apiStartAndFinishShiftByUser,
  apiUpdateShiftOwner,
  apiCancelShiftRequest,
  apiDeleteDuty,
  apiSetWaitingDutyStatus,
}
